













import { Vue, Component } from 'vue-property-decorator'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'

/* eslint-disable indent */
@Component({
    name: 'devices-panel',
    components: { SettingsHeader, SettingsSection, SettingsRow }
})
/* eslint-enable indent */
export default class DevicesPanel extends Vue {

}
